/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2020 KLEARNOW Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KLEARNOW Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KLEARNOW Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KLEARNOW Corporation.
 */

// import * as actions from '../actions/initializeValues';
// import { demoShipments } from '../util/demoShipments'
// import { dummyDataContainerInfo, coors } from '../util/testJSON'
// import { shipmentListData, shipmentActivityDetail, shipmentsCurrentLocation } from '../data/shipmentData'

const initialState = {
  // initialValues
}

export default function BondInfoReducer(state = initialState, action) {
  switch (action.type) {
    case 'INITIALIZE_VALUES_BOND_INFO': {
      return Object.assign({}, state, { ...action.payload })
    }
    case 'UPDATE_BOND_INFO_FIELD': {
      return Object.assign({}, state, { [action.field]: action.payload })
    }
    case 'UPDATE_ADDITIONAL_BOND_INFO_FIELD': {
      let additionalBonds = state.additionalBonds.slice()
      additionalBonds[action.index][action.field] = action.payload
      return Object.assign({}, state, { additionalBonds })
    }
    case 'UPDATE_ACTOR_ADDRESS': {
      return Object.assign({}, state, { ...action.payload })
    }
    case 'ADD_ADDITIONAL_BOND': {
      let additionalBonds = state.additionalBonds.slice()
      let newBond = {
        bondType: '',
        suretyNumber: '',
        bondValue: 0,
        expirationDate: {
          epochs: Date.now() / 1000
        },
        singleTransactionBondProducerAccountNumber: ''
      }
      additionalBonds.push(newBond)
      return Object.assign({}, state, { additionalBonds })
    }
    case 'REMOVE_ADDITIONAL_BOND': {
      let additionalBonds = state.additionalBonds.slice(0, action.payload).concat(state.additionalBonds.slice(action.payload + 1))
      return Object.assign({}, state, { additionalBonds })
    }
    default:
      return state
  }
}
